/**
 * File header.js.
 */

(function ($) {
	'use strict';

	$(document).ready(function () {

		headerSizeSpace();
		$('ul.primary-menu li.menu-item-has-children > a').append('<span class="menu-has-plus-icon"></span>');
		//$('ul.primary-menu li > a').prepend('<span class="menu-has-globe-icon"></span>');

		// resize functions calls
		$(window).on('resize', function () {
			headerSizeSpace();
		});

		// return if link is #
		$(document).on('click', 'a[href="#"]', function () {
			return false;
		});

		$(document).on('click', 'ul.primary-menu li.menu-item-has-children .menu-has-plus-icon', function () {
			$(this).toggleClass('menu-has-minus-icon');
			$(this).parent('a').parent().toggleClass('menu-item-has-children-active');
			$(this).parent('a').siblings('.sub-menu, .children').toggle();
			$('.site-header__menu .dropdown-toggle').addClass('show');
			$('.site-header__menu .dropdown-menu').addClass('show');
			return false;
		});

		$(document).on('click', '.site-header__bottom-left .dropdown-toggle', function () {
			if ( $(this).parent('.dropdown').find('.dropdown-menu').hasClass('show') ) {
				$(".site-header__bottom-right").addClass('hidden-for-mobile');
			} else {
				$(".site-header__bottom-right").removeClass('hidden-for-mobile');
			}
		});

		$(document).on('click', 'body', function () {
			if ( $('.site-header__bottom-left').find('.dropdown').find('.dropdown-menu').hasClass('show') ) {
				$(".site-header__bottom-right").addClass('hidden-for-mobile');
			} else {
				$(".site-header__bottom-right").removeClass('hidden-for-mobile');
			}
		});

		$(document).on('click', '.site-header .site-header__top-action li.search a', function () {
			//$('.site-header .site-header__search-popup').toggle('show');
			$('.site-header .site-header__search-popup').toggleClass('toggled');
			$(this).parent().toggleClass('toggled');
			//$('body').toggleClass('off-scroll');
		});

		$(document).on('click', '.site-header ul.primary-menu li .submenu-toggle', function () {
			const windowWidth = $(window).outerWidth();
			if (1200 > windowWidth) {
				$(this).parent('li').toggleClass('active');
				$(this).siblings('.sub-menu, .children').slideToggle();
			}
		});

		$('.site-header ul.primary-menu li').hover(function () {
			const windowWidth = $(window).outerWidth();
			if (1199 < windowWidth && $(this).hasClass('menu-item-has-children')) {
				$(this).toggleClass('active').siblings().removeClass('active');
			}
		});

		// Sticky Header
		$(window).scroll(function () {
			if ($(window).scrollTop() >= 80) {
				$('.site-header').addClass('fixed-header');
			} else {
				$('.site-header').removeClass('fixed-header');
			}
		});
	});

	function headerSizeSpace() {
		console.log('headerSizeSpace called');
		let parentDiv = $('.site-header__top');
		let windowWidth = $(window).outerWidth();

		// Select the element with class "site-header__label"
		var text = $(".site-header__label").text();

		// Count characters including spaces
		var count = text.length;
		let sideHeaderTopRight = count * 8 + 350; // Approximate width in pixels
		if (count < 15) {
			sideHeaderTopRight = count * 8 + 300;
		}

		if (windowWidth <= sideHeaderTopRight) {
			parentDiv.css('flex-direction', 'column');
			parentDiv.addClass('site-header__top-flex-column');

			// Allow label to wrap and calculate max width
			let topButtonTextWidth = windowWidth - 108; // total width - left padding - right padding - dropdown width
			$('.site-header__top-flex-column .site-header__label').css({
				'width': topButtonTextWidth + 'px',
				'white-space': 'normal',       // allow wrapping
				'word-break': 'break-word',    // break long words if needed
				'line-height': '1.2em'         // optional: adjust line height
			});
		} else {
			parentDiv.css('flex-direction', 'row');
			$('.site-header__top-flex-column .site-header__label').css({
				'width': 'initial',
				'white-space': 'nowrap',       // keep single line
				'word-break': 'normal'
			});
		}

		let header = $('.site-header');
		if (0 < header.length) {
			$('body:not(.has-transparent-header) .site-main').css('padding-top', header.outerHeight());
		}
	}

})(jQuery);
